import SelectorEngine from "../dom/selector-engine";
import EventHandler from "../dom/event-handler.js";
import Toast from "../toast";

const DefaultType = {
	...Toast.DefaultType,
	parent: "string",
};

const Default = {
	...Toast.Default,
	parent: "",
};

class NotificationToast extends Toast {
	constructor(element, config) {
		super(element, config);

		this._parentElement = this._config.parent
			? SelectorEngine.findOne(this._config.parent)
			: "";

		this._isParentInteracting = false;
		this._toastInstances = [];

		if (this._parentElement) {
			this._setParentListeners();
		}
	}

	_onInteraction(event, isInteracting) {
		if (this._parentElement) {
			const toastsInParent = SelectorEngine.find(
				`.${Toast.NAME}`,
				this._parentElement,
			);

			toastsInParent.forEach((toastEl) => {
				const toastInstance = Toast.getInstance(toastEl);
				if (toastInstance) {
					if (isInteracting) {
						toastInstance._clearTimeout();
					} else {
						const relatedTarget = event.relatedTarget;
						if (
							toastInstance._element === relatedTarget ||
							toastInstance._element.contains(relatedTarget)
						) {
							return;
						}
						toastInstance._maybeScheduleHide();
					}
				}
			});
		} else {
			super._onInteraction(event, isInteracting);
		}
	}

	_setParentListeners() {
		EventHandler.on(
			this._parentElement,
			Toast.EVENT_MOUSEOVER,
			(event) => this._onInteraction(event, true),
		);
		EventHandler.on(
			this._parentElement,
			Toast.EVENT_MOUSEOUT,
			(event) => this._onInteraction(event, false),
		);
		EventHandler.on(this._parentElement, Toast.EVENT_FOCUSIN, (event) =>
			this._onInteraction(event, true),
		);
		EventHandler.on(
			this._parentElement,
			Toast.EVENT_FOCUSOUT,
			(event) => this._onInteraction(event, false),
		);
	}

	static get Default() {
		return Default;
	}

	static get DefaultType() {
		return DefaultType;
	}
}

export default NotificationToast;
